<svelte:head>
    <title>The Phoenix Pages</title>
</svelte:head>

<script>
	import { onMount } from 'svelte';
    import ShopBrowser from '../lib/ShopBrowser.svelte';
    export let currentRoute;
    
	import { db } from '../api.js';
    let api = {}, selected;
    db.subscribe(val => {
        api = val;
    });
    
    onMount(async () => {
        selected = api.blank.shop;
        
        if (currentRoute.namedParams.id != undefined) {
            selected = api.shops.filter(a => a._id == currentRoute.namedParams.id)[0];
        };
    });
</script>

<div id="main" class="flex flex-col items-center justify-start flex-1 w-full max-h-full overflow-hidden"> 
    <section class="flex-1 w-full max-h-full px-6 py-3 overflow-hidden lg:p-12">
        <ShopBrowser {api} {selected}></ShopBrowser>
    </section>
</div>